module.exports = __webpack_public_path__ + "static/media/year2020_12-sc.d28be6af.jpg";